import { combineReducers } from 'redux';
import sports from './sports';
import sources from './sources';
import playerDetails from './playerDetails';
import gamelogs from './gamelogs';
import playerNews from './playerNews';
import userDetails from './userDetails';
import logoutUser from './logout';
import articles from './articles';
import playerProps from './props';
import sportEvents from './sportevents';
import propsResults from './propsResults';
import teams from './teams';

export default combineReducers({
    sports,
    sources,
    playerDetails,
    gamelogs,
    playerNews,
    userDetails,
    logoutUser,
    articles,
    playerProps,
    sportEvents,
    propsResults,
    teams
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js